export default "__VITE_ASSET__Cwqn9$P6__"